(function () {
  const run = () => {
    const content = document.querySelector('.article-template__content');
    const toc = document.querySelector('[data-article-toc]');
    if (!content || !toc) return;

    const headings = content.querySelectorAll('h2, h3');
    if (!headings.length) {
      toc.closest('.article-sidebar__toc')?.setAttribute('hidden', '');
      return;
    }

    const list = document.createElement('ul');
    list.className = 'article-toc__list';
    const links = [];

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = 'article-section-' + index;
      const item = document.createElement('li');
      item.className = 'article-toc__item article-toc__item--' + heading.tagName.toLowerCase();
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.innerHTML =
        '<span class="article-toc__num">' +
        String(index + 1).padStart(2, '0') +
        '</span><span class="article-toc__text">' +
        heading.textContent.trim() +
        '</span>';
      item.append(link);
      list.append(item);
      links.push({ link, heading });
    });

    toc.append(list);

    const setActive = (id) => {
      links.forEach(({ link }) => {
        link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
      });
    };

    if ('IntersectionObserver' in window && links.length < 30) {
      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
          if (visible[0]) setActive(visible[0].target.id);
        },
        { rootMargin: '-15% 0px -65% 0px', threshold: 0.1 }
      );
      links.forEach(({ heading }) => observer.observe(heading));
    }

    links.forEach(({ link }) => {
      link.addEventListener('click', () => setActive(link.getAttribute('href').slice(1)));
    });

    if (links.length) setActive(links[0].heading.id);
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(run, { timeout: 1500 });
  } else {
    window.addEventListener('DOMContentLoaded', run, { once: true });
  }
})();
